<template>
  <o-view class="c-view--route">
    <o-block-list class="c-route-form">
      <o-nav-bar title="Route" :has-back-button="true" />
      <o-section>
        <o-text-input
          icon="start"
          placeholder="Vertrek"
          value="Huidige locatie"
          ref="startInput"
        />
        <o-floating-button icon="swap" />
      </o-section>
      <o-section>
        <o-text-input
          icon="destination"
          placeholder="Aankomst"
          value="Antwerpen-Centraal"
        />
      </o-section>
      <o-section>
        <o-text-input icon="date" placeholder="Nu" type="date" />
      </o-section>
    </o-block-list>
    <div class="c-route-results">
      <div class="c-route-result" />
      <div class="c-route-result" />
      <div class="c-route-result" />
      <div class="c-route-result" />
      <div class="c-route-result" />
    </div>
  </o-view>
</template>

<script>
export default {
  name: 'Route'
}
</script>

<style lang="scss">
.c-view--route {
  display: flex;
  flex-direction: column;
}

.c-route-form {
  flex: none;
  position: relative;
  z-index: 1;
}

.c-route-results {
  flex: 1 1 0;
  overflow: auto;
  padding: 1.6rem;
}

.c-route-result {
  background: #fff;
  border-radius: $border-radius-small;
  box-shadow: $box-shadow;
  height: 12rem;

  & + & {
    margin-top: 0.8rem;
  }
}

.c-floating-button {
  bottom: -2.4rem;
  right: 1.6rem;
}
</style>
